<mat-toolbar class="p-0 mat-elevation-z1" *ngIf="isToolbarEnabled">
  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
      <button
        mat-icon-button
        class="navbar-toggle-button"
        *ngIf="!hiddenNavbar && !rightNavbar"
        (click)="toggleSidebarOpen('navbar')"
        fxHide.gt-md>
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>

      <div
        class="toolbar-separator"
        *ngIf="!hiddenNavbar && !rightNavbar"
        fxHide.gt-md></div>

      <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
        <div class="logo ml-16">
          <img class="logo-icon" src="assets/images/logos/fuse.svg" />
        </div>
      </div>

      <div fxShow.gt-sm fxHide class="px-8 px-md-16">
        <!-- <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts> -->
        <span style="font-size: 19px; font-weight: normal"
          >{{ dateNow | date: 'EEEE, d ' | titlecase }} de
          {{ dateNow | date: ' LLLL ' | titlecase }} de
          {{ dateNow | date: ' yyyy HH:mm a' }}</span
        >
      </div>
    </div>

    <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
      <ng-container *ngIf="showBrowserNotifications">
        <button
          mat-button
          fxHide
          fxShow.gt-xs
          class="language-button"
          [matMenuTriggerFor]="notifyMenu"
          matTooltip="Notificaciones"
          matTooltipPosition="below">
          <div class="mat-icon-custom">
            <mat-icon>notifications</mat-icon>
            <span
              class="badge"
              [ngStyle]="{
                background: enableNotify.value ? 'rgb(9, 180, 95)' : '#f44336'
              }"></span>
          </div>
        </button>

        <mat-menu #notifyMenu="matMenu" [overlapTrigger]="false">
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            style="min-height: auto"
            mat-menu-item
            (click)="$event.stopPropagation()">
            <mat-slide-toggle
              name="enableNotify"
              [formControl]="enableNotify"
              (change)="toggleNotifications($event.checked)"
              ><span>
                {{
                  (enableNotify.value
                    ? 'TOOLBAR.NOTIFICATIONS.DISABLE'
                    : 'TOOLBAR.NOTIFICATIONS.ENABLE'
                  ) | translate
                }}
              </span></mat-slide-toggle
            >
          </div>
        </mat-menu>

        <div class="toolbar-separator"></div>
      </ng-container>

      <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
        <div fxLayout="row" fxLayoutAlign="center center">
          <img
            class="avatar mr-0 mr-sm-16"
            src="assets/images/avatars/profile.jpg" />
          <span class="username mr-12" fxHide fxShow.gt-sm
            >{{ user.firstName == null ? '' : user.firstName }}
            {{ user.lastName == null ? '' : user.lastName }}</span
          >
          <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
        </div>
      </button>

      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        <div class="toolbar-separator"></div>

        <button
          mat-menu-item
          routerLink="/pages/profile"
          *ngIf="showMyProfileButton">
          <mat-icon>account_circle</mat-icon>
          <span>{{ 'TOOLBAR.MY_PROFILE' | translate }}</span>
        </button>

        <!-- <button mat-menu-item class="">
                    <mat-icon>mail</mat-icon>
                    <span>Inbox</span>
                </button> -->

        <button mat-menu-item class="" (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>
          <span>{{ 'TOOLBAR.LOGOUT' | translate }}</span>
        </button>
      </mat-menu>

      <div class="toolbar-separator"></div>

      <!-- BUSQUEDA
           <fuse-search-bar (input)="search($event)"></fuse-search-bar>

            <div class="toolbar-separator"></div> -->

      <button
        mat-button
        fxHide
        fxShow.gt-xs
        class="language-button"
        [matMenuTriggerFor]="languageMenu"
        *ngIf="hideLangList">
        <div fxLayout="row" fxLayoutAlign="center center">
          <img
            class="flag mr-8"
            [src]="'assets/icons/flags/' + selectedLanguage.flag + '.png'" />
          <span class="iso text-uppercase">{{ selectedLanguage.id }}</span>
        </div>
      </button>

      <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
        <button
          mat-menu-item
          *ngFor="let lang of languages"
          (click)="setLanguage(lang)">
          <span fxLayout="row" fxLayoutAlign="start center">
            <img
              class="flag mr-16"
              [src]="'assets/icons/flags/' + lang.flag + '.png'" />
            <span class="iso">{{ lang.title }}</span>
          </span>
        </button>

        <!-- <button mat-menu-item [routerLink]="'/components/multi-language'">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <span>{{ 'TOOLBAR.LEARN_MORE' | translate }}</span>
                    </div>
                </button> -->
      </mat-menu>

      <div class="toolbar-separator" fxHide fxShow.gt-xs></div>
      <!--
            <button mat-icon-button fxHide.gt-md class="chat-panel-toggle-button"
                (click)="toggleSidebarOpen('chatPanel')" aria-label="Toggle chat panel">
                <mat-icon class="secondary-text">chat</mat-icon>
            </button>

            <div class="toolbar-separator" fxHide.gt-md></div>

            <button mat-icon-button class="quick-panel-toggle-button" (click)="toggleSidebarOpen('quickPanel')"
                aria-label="Toggle quick panel">
                <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

            <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && rightNavbar"
                (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button> -->
    </div>
  </div>
</mat-toolbar>
